// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartsComponent_wrapper__gTBiC","title":"ChartsComponent_title__CzPOS","t_score":"ChartsComponent_t_score__LXnWH","red_row_table":"ChartsComponent_red_row_table__789NB"};